import React from 'react'
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Checkbox } from 'react-bootstrap'
import { TextInput, LabelGroup, InsetSection, Tags, JsonEditorDialog, Text, Flex } from '~/views';

import style from './style.css'

export default class SystemEditor extends React.Component {

  static propTypes = {
    system : PropTypes.object,
    currentTags : PropTypes.object,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { showDialog : false }
  }

  changePath( path, value, err ) {
    if ( err ) {
      console.log( `error setting ${key} to ${value}` );
      return;
    }
    this.props.onChange( { target : this.props.system, path, value } );
  }

  render() {
    const { system, small } = this.props
    if ( system == null ) {
      return <div />
    }

    let alias = null
    let pWrite = null
    if ( system.anonymousPermissions == null && system.isPublic ) {
      pWrite = ( 
        <Checkbox
          checked={system.isPubliclyWritable === true} 
          onChange={( e ) => { this.changePath( 'isPubliclyWritable', e.target.checked, false ) }}>
          Publicly Writeable
        </Checkbox>
      )
    }
    alias = ( 
      <LabelGroup>
        <label>Alias Name</label>
        <TextInput
          hint=""
          value={system.alias} 
          acceptKey={keyValidator}
          changeOnReturn 
          onChange={( v, err ) => { this.changePath( 'alias', v, err ) }} />
      </LabelGroup>
    )
  
    let metadata
    if ( system.metadata ) {
      metadata = JSON.stringify( system.metadata, null, 2 )
    }

    return (
      <Flex variant="vSpace" direction="column" align="stretch">
        <LabelGroup>
          <label>ID</label>
          <Text type="dim" text={system.id} />
        </LabelGroup>
        <LabelGroup>
          <label>Name</label>
          <TextInput
            hint="Name..."
            value={system.name} 
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'name', v, err ) }} />
        </LabelGroup>
        <LabelGroup>
          <label>Description</label>
          <TextInput
            hint="Description..."
            value={system.desc}
            changeOnReturn 
            onChange={( v, err ) => { this.changePath( 'desc', v, err ) }} />
        </LabelGroup>
        {alias}
        <LabelGroup>
          <label>Tags</label>
          <Tags
            tags={system.tags}
            autofocus={false}
            suggestions={this.props.currentTags}
            tagAdded={( tag, arr ) => { this.changePath( 'tags', arr, false ) }}
            tagRemoved={( tag, arr ) => { this.changePath( 'tags', arr, false ) }} />
        </LabelGroup>

        <LabelGroup>
          <label />
          <div>
            <Checkbox
              checked={system.allowTextAlerts == null ? true : system.allowTextAlerts} 
              onChange={( e ) => { this.changePath( 'allowTextAlerts', e.target.checked, false ) }}>
              Allow Text Alerts
            </Checkbox>
          
            <Checkbox
              checked={system.allowEmailAlerts == null ? true : system.allowEmailAlerts} 
              onChange={( e ) => { this.changePath( 'allowEmailAlerts', e.target.checked, false ) }}>
              Allow Email Alerts
            </Checkbox>
          </div>
        </LabelGroup>

        {system.anonymousPermissions == null && 
        (
          <LabelGroup style={{ alignItems : 'baseline' }}> 
            <label>Permissions</label>
            <div>
              <Checkbox
                checked={system.isPublic === true} 
                onChange={( e ) => { this.changePath( 'isPublic', e.target.checked, false ) }}>
                Public
              </Checkbox>
              {pWrite}
            </div>
          </LabelGroup>
        )}
          
        <LabelGroup vertical>
          <div>
            <label>Metadata</label>
            <Button style={{ marginLeft : '10px' }} bsSize="sm" bsStyle="link" onClick={() => { this.setState( { showDialog : true } ) }}>Edit</Button>
          </div>
          <InsetSection style={{ width : '100%' }}>
            <div className={metadata ? style.metadata : style.noMetadata}>{metadata || 'No metadata' }</div> 
          </InsetSection>
        </LabelGroup>

        <LabelGroup>
          <label />
          <Text type="dim" className={style.identifier}>
            {`created ${moment( system.created ).format( 'lll' )}` }
          </Text>
        </LabelGroup>
        <JsonEditorDialog 
          title="System Metadata"
          message="Enter the JSON object for the metadata"
          show={this.state.showDialog} 
          onOk={( val ) => { 
            system.metadata = val; 
            this.changePath( 'metadata', val, false )
            this.setState( { showDialog : false } ) 
          }}
          onCancel={() => { this.setState( { showDialog : false } ) }}
          value={system.metadata} />
          
      </Flex>
    ) 
  }
}

function keyValidator( evt ) {
  const inp = String.fromCharCode( evt.charCode );
  const c = evt.charCode;
  if ( /[a-zA-Z0-9_\-:]/.test( inp ) ) {
    return true;
  }
  return false;
}
